import { render, staticRenderFns } from "./cibRecoveries.vue?vue&type=template&id=454fef14&scoped=true"
import script from "./cibRecoveries.vue?vue&type=script&lang=js"
export * from "./cibRecoveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454fef14",
  null
  
)

export default component.exports